export const LIKE_POST        = 'LIKE_POST';
export const UNLIKE_POST      = 'UNLIKE_POST';
export const REMOVE_POST      = 'REMOVE_POST';
export const ADD_REPLY        = 'ADD_REPLY';
export const LIKE_REPLY       = 'LIKE_REPLY';
export const UNLIKE_REPLY     = 'UNLIKE_REPLY';
export const REMOVE_REPLY     = 'REMOVE_REPLY';
export const ADD_REPLIES      = 'ADD_REPLIES';
export const UPDATE_FEED_POST = 'UPDATE_FEED_POST';
export const UPDATE_FEED_REPLY_COMMENT = 'UPDATE_FEED_REPLY';



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/constants.es6